import request from '@/utils/request'

/**
 * 获取通知列表
 * @param {Object} params - 查询参数
 * @param {number} [params.notify_type] - 通知类型（1-9）
 * @param {number} [params.is_read] - 已读状态（0未读 1已读）
 * @param {number} [params.channel] - 渠道（1站内 2短信 3微信）
 * @param {string} [params.keyword] - 关键词（标题/内容）
 * @param {string} [params.start_date] - 开始日期（Y-m-d）
 * @param {string} [params.end_date] - 结束日期（Y-m-d）
 * @param {number} [params.page] - 页码
 * @param {number} [params.per_page] - 每页数量
 * @returns {Promise}
 */
export function getNotificationList(params) {
  return request({
    url: '/notifications',
    method: 'get',
    params
  })
}

/**
 * 获取未读数量统计（含按类型分组）
 * @returns {Promise}
 */
export function getNotificationUnreadCount() {
  return request({
    url: '/notifications/unread-count',
    method: 'get'
  })
}

/**
 * 标记单条通知已读
 * @param {number} id - 通知ID
 * @returns {Promise}
 */
export function markNotificationRead(id) {
  return request({
    url: `/notifications/${id}/read`,
    method: 'put'
  })
}

/**
 * 全部标记已读
 * @param {Object} [data] - 请求体
 * @param {number} [data.notify_type] - 通知类型（不传则标记所有未读）
 * @returns {Promise}
 */
export function markAllNotificationsRead(data) {
  return request({
    url: '/notifications/read-all',
    method: 'put',
    data
  })
}
